'use strict';

module.exports = function formatSimple(element) {
    return element.text;
};
